import { render, staticRenderFns } from "./ModalEditParcel.vue?vue&type=template&id=11fa0674&scoped=true&"
import script from "./ModalEditParcel.vue?vue&type=script&lang=js&"
export * from "./ModalEditParcel.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditParcel.vue?vue&type=style&index=0&id=11fa0674&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fa0674",
  null
  
)

export default component.exports